import DocumentView from "./DocumentView";

export default DocumentView;
